<!-- 车位周转数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "startDate": "20190910000000",
                "endDate": "20190910235959",
            },
            responseCode: {
                    "data": {
                        "recordList": [
                            {
                                "enterSize": 4,
                                "id": 726,
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkingNum": 380,
                                "statDate": 1568563200000,
                                "statDateText": "2019-09-16",
                                "turnoverRate": 0.0105
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车位周转数据",
                t_url: this.commonUrls.test+"parkingPlaceTurnOver",
                p_url: this.commonUrls.prod+"parkingPlaceTurnOver",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'startDate', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endDate', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'long', info4: 'id' },
                        { info1: 'parkId', info2: '是', info3: 'String', info4: '车场uuid' },
                        { info1: 'statDate', info2: '是', info3: 'long', info4: '统计日期（格式:2019-09-09）' },
                        { info1: 'statDateText', info2: '是', info3: 'String', info4: '支付时间,yyyy-MM-dd' },
                        { info1: 'enterSize', info2: '是', info3: 'Integer', info4: '进场车辆数' },
                        { info1: 'parkingNum', info2: '是', info3: 'Integer', info4: '车位总数' },
                        { info1: 'turnoverRate', info2: '是', info3: 'Integer', info4: '车位周转率=进场车辆数/车位总数' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/parkingPlaceTurnOver.vue